import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { usePageVersionView } from '../../hooks/usePageVersionView';
export var TrackedPageVersionView = function (_a) {
    var spring_doc_id = _a.spring_doc_id, refer = _a.refer;
    usePageVersionView(spring_doc_id, refer);
    return _jsx(_Fragment, {});
};
